/**
 * The product identity block at the top of an auth card: the "Campus Solutions" eyebrow and the
 * "Timesheets" heading.
 *
 * Shared by the sign-in card and the OIDC callback rather than duplicated, for the same reason
 * `AuthShell` exists: two copies drift. That is not hypothetical here — the product name of
 * record is still an open decision (three names are currently visible across the app), so this
 * string is expected to change, and the fidelity harness only captures `/`, so a divergent
 * callback heading would ship unnoticed.
 *
 * Kept out of `AuthShell` itself so the shell stays a general chrome-free frame that a future
 * 404 or maintenance page can reuse with its own heading.
 */
export function AuthCardHeading() {
  return (
    <>
      <div className="signin-eyebrow">Campus Solutions</div>
      <h1 className="signin-title">Timesheets</h1>
    </>
  );
}
